<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    Status Change - Information Required
  </h5>
</div>
<div class="modal-body" ngbAutofocus>
  <div class="row">
    <div class="col">
      <p>Please provide a reason for the status change:</p>
      <p>
        <ng-container [formGroup]="reasonFormGroup">
          <app-dc-input
            [label]="'Reason'"
            [id]="'reason'"
            type="text"
            formControlName="reason"
            customErrorMessage="Please provide a minimum of 10 characters"
          ></app-dc-input>
        </ng-container>
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div>
    <button
      type="button"
      class="btn btn-secondary btn-sm mr-3"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      [disabled]="!reasonFormGroup.get('reason').valid"
      type="button"
      class="btn btn-primary btn-sm"
      (click)="onSave(reasonFormGroup.get('reason').value)"
    >
      Save
    </button>
  </div>
</div>
